/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsExchange2 = createReactComponent("outline", "arrows-exchange-2", "IconArrowsExchange2", [["path", { "d": "M17 10h-14l4 -4", "key": "svg-0" }], ["path", { "d": "M7 14h14l-4 4", "key": "svg-1" }]]);

export { IconArrowsExchange2 as default };
//# sourceMappingURL=IconArrowsExchange2.mjs.map
